import { defineComponent } from 'vue';
import { QIcon } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

const TIMELINE_CLICK_CODE_BEHIND = {
    handlerSuffix: '_Click',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your click handler here\n\t}`;
    },
};

export default defineComponent({
    name: 'cc-timeline-dsgn',
    mixins: [BaseComponentMixin],
    components: { QIcon },
    computed: {
        containerStyle() {
            return {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#ececec',
                color: '#616161',
                minHeight: '120px',
                ...utils.getSize(this.controlData?.SizeOptions, this.parentType, this.$parent),
                ...utils.getStyleHints(this.controlData?.StyleHints, this),
            };
        },
    },
    methods: {
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, TIMELINE_CLICK_CODE_BEHIND);
        },
    },
    render() {
        if (!this.controlData)
            return null;

        return (
            <div
                class={{ 'c-Timeline': true, 'designer-container': true, selected: this.selected$ }}
                style={this.containerStyle}
                onClick={(e) => this.handleClick(e)}
                onDblclick={(e) => this.handleDesignerDblClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />
                <QIcon name="mdi-chart-gantt" size="lg" color="grey-7" />
                <div style={{ marginTop: '8px', fontSize: 'smaller' }}>Timeline</div>
            </div>
        );
    },
});
